import type { EnvCode } from '@/types/types'

/**
 * Returns a simplified environment code ('mu', 'pro', 'hk', 'cn' or 'com') 
 * based on the current VITE_ENV value.
 * 
 * - 'dev-mu' or 'prod-mu'  => 'mu'
 * - 'dev-pro' or 'prod-pro' => 'pro'
 * - 'dev-hk' or 'prod-hk' => 'hk'
 * - 'dev-cn' or 'prod-cn' => 'cn'
 * - anything else           => 'com'
 * 
 * Useful for routing, environment-specific logic, or dynamic URL handling.
 */
export const getEnv = (): EnvCode => {
  const env = import.meta.env.VITE_ENV

  if (env === 'dev-mu' || env === 'prod-mu') return 'mu'
  if (env === 'dev-pro' || env === 'prod-pro') return 'pro'
  if (env === 'dev-hk' || env === 'prod-hk') return 'hk'
  if (env === 'dev-cn' || env === 'prod-cn') return 'cn'
  return 'com';
}